module.exports = __webpack_public_path__ + "img/act-黑名单.a330b3f1.png";